(ns ycweb.app.pos.integration.mpos
  (:require
   [ycweb.util.core :as u]
   [ycweb.util.comms :as comms]
   [ycweb.app.pos.integration.common :as common]))

(defn on-terminal? []
  ;; Device-type detection: scanner-only devices (khumo/honeywell) have no payment
  ;; terminal; everything else (sunmi, pre-capability APKs, browsers) defaults to true.
  #?(:clj false
     :cljs
     (cond
       (u/capability-exists? :sumni)
       true

       (u/capability-exists? :khumo)
       false

       (u/capability-exists? :honeywell)
       false

       :else true)))

;; defonce, not def: a cljs hot-reload re-evaluates def and would hand back a NEW atom, while
;; window.paymentPebbleResponse still closes over the integration map captured at page load —
;; the old one. handle-call would then write the new atom and the terminal callback would read
;; the old (stale) one, judging a fresh SALE against a previous action. defonce keeps one atom
;; across reloads. Behaviour changes to the integration map still need a full page reload.
(defonce current-action (atom nil))

(def emulate-messages
  {:success
   (fn [sale]
     {:isReceiptDataAvailable "true",
      :appVersion "2.0.0",
      :applicationKey "b63f2cee-86b1-4f8b-a428-ce91b9c01b7e",
      :launchType "SALE",
      :customerName "null",
      :merchantName "Yuppiechef Online",
      :transactionDescription (:reference sale),
      :resultCode "00",
      :merchantID "910400000000087",
      :longitude "0.0",
      :receiptBundle [{:MERCHANT_REGION_CODE "09"}
                      {:RC_ALT "00"}
                      {:SEQ_NO "000"}
                      {:STATUS "APPROVED"}
                      {:BUDGET_PERIOD ""}
                      {:CARD_TYPE "Hybrid"}
                      {:PAN_WITH_BIN "387478** **** 8482"}
                      {:MERCHANT_ID "910400000000087"}
                      {:TIMESTAMP "1572952788888"}
                      {:EXTERNAL_TRANSACTION_DATETIME "2019-11-05T13:19:11"}
                      {:PROCESSING_CODE "1000"}
                      {:RC_DESCRIPTION "Approved"}
                      {:EXTERNAL_INVOICE_GUID "765789cd-92ec-41ff-91e5-a1dd87f52d1e"}
                      {:REPLACEMENT_MERCHANT_ID ""}
                      {:BATCH_NO "000"}
                      {:TXN_CNTR "0226"}
                      {:AUTH_PROFILE "11"}
                      {:INTERCHANGE "Hybrid"}
                      {:ESC_BY_AUTH_CODE "206 00 IH 123456"}
                      {:TX_TYPE "DEBIT"}
                      {:ACC_TYPE_DESC "Savings"}
                      {:CURRENCY_CODE "ZAR"}
                      {:AUTH_CODE "123456"}
                      {:RC "00"}
                      {:AID "A0000000041010"}
                      {:CRY "84EE0B404FFF9155"}
                      {:CVM "PIN Verified"}
                      {:IAD "0810A71113023000000000000000000000FF"}
                      {:PAN "**** **** **** 8482 "}
                      {:RRN "930123123095"}
                      {:APSN "00"}
                      {:DATE "2019-11-05T11:19:48.888+0000"}
                      {:STAN "92095"}
                      {:NAME_ON_CARD "PERSON/SP.MR             "}
                      {:ABS_AMOUNT (u/currency-format (:amount sale))}
                      {:RECEIPT_NUMBER ""}
                      {:TERMINAL_ID "91004517"}
                      {:TX_TYPE_DESCRIPTION "SALE"}
                      {:EXTERNAL_TERMINAL_ID "91004517"}
                      {:FORMATTED_OTHER_AMOUNT "R 0.00"}
                      {:FORMATTED_AMOUNT (str (u/currency-format (:amount sale)))}
                      {:DESCRIPTION "476077"}
                      {:SETTLEMENT_DATE "2019-11-05T00:00:00.000+0000"}
                      {:EXTERNAL_TRANSACTION_GUID "b85c85d9-f3f4-467b-85c2-cb8c0a802cb1"}
                      {:CARD_BIN "387478"}
                      {:TRANSACTION_INFO "20600111682AA"}
                      {:REPLACEMENT_TERMINAL_ID ""}
                      {:POS_ENTRY "51"}
                      {:RC_ISO_DESCRIPTION "Approved"}
                      {:MERCHANT_CITY "Cape Town"}
                      {:MERCHANT_NAME "Yuppiechef Online"}
                      {:OTHER_AMOUNT "0.00"}
                      {:APP_VERSION "2.0.0"}
                      {:CARD_SEQ_NO "0"}
                      {:APP_LABEL "MasterCard"}
                      {:INVOICE_NUM ""}
                      {:MESSAGE_1 ""}
                      {:MESSAGE_2 ""}
                      {:MERCHANT_COUNTRY_CODE "ZA"}
                      {:REPRINT ""}
                      {:PAN_HASH "C50F5AD143172459602E057DBE236101AAAA5D531CE7FAEC9E388B00DE30C1D"}
                      {:AMOUNT (u/currency-format (:amount sale))}
                      {:DIGITS "8482"}
                      {:CVM_ABSA "PIN Verified"}],
      :externalTransactionDateTime "null",
      :buildInfo "ECENTRIC_PROD",
      :transactionUuid "b85c85d9-f3f4-467b-85c2-cb8c0a802cb1",
      :transactionLinkIdentifier "TLI123456789",
      :externalTransactionGUID "GUID-V2-123456789",
      :externalSTAN "456",
      :externalTerminalId "null",
      :emailAddressToSendReceipt "",
      :authenticationKey "d1ed3a46-d1dd-4673-b888-6777030ac364",
      :resultDescription "APPROVED",
      :cellNumberToSMSReceipt "",
      :externalInvoiceGUID "null",
      :alwaysShowTransactionStatusScreen "false",
      :invoiceNumber "null",
      :isReceiptRequired "false",
      :latitude "0.0",
      :transactionAmount (str (:amount sale)),
      :transactionReferenceNo (:reference sale),
      :merchantUsername "default"})

   :cancelled
   (fn [sale]
     {:appVersion "2.0.0",
      :applicationKey "b63f2cee-86b1-4f8b-a428-ce91b9c01b7e",
      :errorBundle [{:description ""}
                    {:reference "null"}
                    {:errorType "USER_CANCELLED"}
                    {:message "User exited application"}],
      :launchType "SALE",
      :merchantName "Yuppiechef Online",
      :resultCode "03",
      :merchantID "910400000000087",
      :buildInfo "ECENTRIC_PROD",
      :authenticationKey "d1ed3a46-d1dd-4673-b888-6777030ac364",
      :resultDescription "ABORTED",
      :serialNumber "B367C6311C08E13FFF08047453",
      :merchantUsername "default"})

   :refund
   (fn [sale]
     {:launchType "REFUND"
      :resultCode "00"
      :amount (:amount sale)
      :originalTransactionUuid (:uuid sale)})

   :timeout
   (fn [sale] nil)

   :crash
   (fn [sale] #?(:cljs (.reload js/location)))})

(def integration
  {:state-key :mpos
   :config-key :thumbzup
   :send-payment-uuid? true
   :auth-label "Ecentric Authorisation"
   :comms-method :ecentric/retail-auth
   :approved?
   ;; Ecentric success codes differ per operation. RETAIL_AUTH completes on "00",
   ;; Everything else approves (SALE/REFUND/TX_SEARCH) on "01".
   ;; https://ecentric.readme.io/docs/integration-overview
   (fn [response]
     (case (:launchType response)
       "SALE" (= "01" (:resultCode response))
       "QR_CODE_PAYMENT" (= "01" (:resultCode response))
       "REFUND" (= "01" (:resultCode response))
       "TX_SEARCH" (= "01" (:resultCode response))
       (= "00" (:resultCode response))))
   :parse-response
   ;; The V2 Legacy app wraps responses in the legacy thumbzup envelope.
   (fn [parsed]
     (or
       (:ecentricApplicationResponse parsed)
       (:thumbzupApplicationResponse parsed)))
   :match-reference?
   ;; The payment-uuid is the authoritative match: we send it as transactionUuid (SALE) and
   ;; search by it (TX_SEARCH), and the terminal echoes the exact transaction back. When it's
   ;; present, match on it. Only fall back to amount when there is no payment-uuid (the amount
   ;; is sourced differently on a status re-check, so it's not reliable to require on top).
   (fn [data response]
     (if (:payment-uuid data)
       (= (str (:payment-uuid data))
          (str (or (:transactionUuid response)
                   (:externalTransactionGUID response))))
       (= (str (:amount data)) (str (:transactionAmount response)))))
   :serial-key :serialNumber
   :device-fn on-terminal?
   :current-action current-action
   :emulate-messages emulate-messages
   :launch-payment
   #?(:clj (fn [_]) :cljs (fn [json] (.launchPaymentPebble js/PebbleInterface json)))
   :init-payment
   #?(:clj (fn [_]) :cljs (fn [json] (.initialisePaymentPebble js/PebbleInterface json)))
   :get-response
   #?(:clj (fn []) :cljs (fn [] (.getJsonResponse js/PebbleInterface)))
   :get-error
   #?(:clj (fn []) :cljs (fn [] (.getErrorMessage js/PebbleInterface)))
   :get-log
   #?(:clj (fn []) :cljs (fn [] (.getLogMessage js/PebbleInterface)))})

(defmethod comms/receive :ecentric/retail-auth [app-atom config]
  ((common/make-retail-auth-handler integration) app-atom config))

(defn handle-call
  [app-atom calltype sale success-fn fail-fn & [error-fn]]
  (common/handle-call integration app-atom calltype sale success-fn fail-fn error-fn))
